<template>
  <div
    class="press-material-list-item flex relative flex-wrap pb-semi mx-0 lg:-mx-tiny "
    data-test-id="component-press-material-list-item"
  >
    <div
      v-if="item.file"
      class="item-featured-image block w-full pr-0 px-0 lg:px-standart"
      data-test-id="block-press-material-list-item-file"
    >
      <button
        type="button"
        data-test-id="link-press-material-list-item-image-download-file"
        class="outline-none"
        aria-label="Download file"
        @click="downloadFile"
      >
        <img
          v-if="hasImage"
          :src="`${imageUrl}?fit=crop&ar=4:3&w=400`"
          :alt="item.title"
          class="max-w-100 h-auto"
        >
        <img
          v-else
          :blank="true"
          :alt="item.title"
          class="ratio4-3 max-w-100 h-auto"
        >
      </button>
    </div>
    <div class="block w-full px-standart mt-tiny">
      <button
        type="button"
        class="download-link text-infra-violette outline-none"
        data-test-id="link-press-material-list-item-download-file"
        @click="downloadFile"
      >
        <MajorityUiMajorityIcon icon="download" class="icon" />
        {{ $messages('press.download') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { IMG_EXTENSIONS } from '@/utils/press-options'

export default {
  name: 'PressMaterialListItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    vertical: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    hasImage () {
      if (this.item.thumbnail && this.item.thumbnail.url) {
        return true
      }

      if (!this.item.file || !this.item.file.url) {
        return false
      }

      for (let i = 0; i < IMG_EXTENSIONS.length; i++) {
        const extension = IMG_EXTENSIONS[i]

        if (this.item.file.url.includes(`.${extension}`)) {
          return true
        }
      }

      return false
    },
    imageUrl () {
      if (this.item.thumbnail && this.item.thumbnail.url) {
        return this.item.thumbnail.url
      }

      return this.item.file.url
    },
    itemFileName () {
      if (!this.item.file || !this.item.file.url) {
        return ''
      }

      return this.item.file.url.split('/').slice(-1)[0]
    },
    itemFileExtension () {
      if (!this.itemFileExtension) {
        return ''
      }

      return this.itemFileExtension.split('.').slice(-1)[0]
    }
  },
  methods: {
    downloadFile () {
      if (!this.item.file || !this.item.file.url) {
        return
      }

      axios({
        method: 'get',
        url: this.item.file.url,
        responseType: 'arraybuffer'
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.itemFileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(() => this.$sentry.captureException(new Error(`Error Downloading File ${this.itemFileName}`)))
    }
  }
}
</script>

<style lang="postcss" scoped>
.ratio4-3 {
  width: 100%;
  background-color: #777;
  height: 0;
  padding: 0;
  padding-bottom: calc(100% * 3 / 4);
}
</style>
